/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */
// baki

import React, { useState, useEffect, useContext, useRef } from 'react';
import moment from 'moment';
import { Button, Collapse, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter, InputGroup } from 'reactstrap';
import { Link } from 'react-router-dom';
import { EmojiButton } from '@joeattardi/emoji-button';
import { Client as ConversationsClient } from '@twilio/conversations';
import Joyride, { STATUS } from 'react-joyride';

// import contexts
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// import services
import AuthService from '../../services/AuthService';
import ChatService from '../../services/ChatService';
import ClientService from '../../services/ClientService';

// local imports`
import ErrorBoundary from '../general/ErrorBoundary';
import notificationSound from '../../assets/notification.mp3';
import './ClientChat.css';

import sendIcon from "../../assets/send.png";
import searchIcon from "../../assets/search.png";

var primaryClient = { user: {} };
let selectedConversationPage = null;
let copyMessages = [];
let currentSearchResult = null;
let currentSearchPage = 0;
let searchResult = [];
let pageSize = 30;

// tutorial pending

const ClientChat = props => {

    let timeout = 0;
    let audio = new Audio(notificationSound);
    let counter = 0;

    // contexts
    const { theme, colors, fontFamily, fontSize, fontWeight } = useContext(ThemeContext);
    const { user, setUser } = useContext(AuthContext);

    // states
    const [connectionLoading, setConnectionLoading] = useState(true);
    const [statusString, setStatusString] = useState("");
    const [conversations, setConversations] = useState([]);
    const [participants, setParticipants] = useState({ primary: { lastReadMessageIndex: 0, identity: "", friendlyName: "", isOnline: false, attributes: { email: "", role: "" } }, secondary: { identity: "", friendlyName: "", isOnline: false, attributes: { email: "", role: "" } } });
    const [selectedConversation, setSelectedConversation] = useState(null);
    const [updateSelectedConversation, setUpdateSelectedConversation] = useState(true);
    // const [selectedConversationPage, setSelectedConversationPage] = useState(null);
    const [selectedProvider, setSelectedProvider] = useState({ isTrue: false });
    const [isShowMoreLoading, setIsShowMoreLoading] = useState(false);
    const [showChatScrollDown, setShowChatScrollDown] = useState(false);
    const [messages, setMessages] = useState([]);
    const [isTyping, setIsTyping] = useState({ status: false, identity: "" });
    const [message, setMessage] = useState("");
    const [showCallRequestPopup, setShowCallRequestPopup] = useState(false);
    const [showVideoRequestPopup, setShowVideoRequestPopup] = useState(false);
    const [search, setSearch] = useState({ visible: false, value: "" });
    const [showNewMessageLine, setShowNewMessageLine] = useState(false);
    const [selectedConversationMessageStatus, setSelectedConversationMessageStatus] = useState({ lastMessage: null });
    const [notifications, setNotifications] = useState({ newChatMessage: [] });
    const [listOfSessions, setListOfSessions] = useState({
        completedSessions: [],
        upcomingSessions: [],
        cancelledSessions: [],
        rescheduleRequestedSession: []
    });
    const [subscriptionDetail, setSubscriptionDetail] = useState({ serviceDetails: {}, clientSubscriptionPlan: {}, conversation: {} });
    const [tutorial, setTutorial] = useState({
        status: false,
        steps: [
            {
                content: <h2>Chat with your selected counsellor from here!</h2>,
                placement: 'center',
                target: '#clientChatDiv',
            },
            {
                content: <div className="tooltipDiv">Save your profile details by pressing this button.</div>,
                placement: 'right',
                target: '#saveBtn',
            }
        ]
    });
    let helpers = null;

    const [isOpenDetails, setIsOpenDetails] = useState(false);
    const [isOpenUpcoming, setIsOpenUpcoming] = useState(false);
    const [isOpenPrevious, setIsOpenPrevious] = useState(false);
    const [toggleTopMenu, setToggleTopMenu] = useState(false);
    const [toggleLeftMenu, setToggleLeftMenu] = useState(false);

    useEffect(() => {
        document.getElementById("root").classList.value = "";
        document.getElementById("root").firstElementChild.firstElementChild.classList.value = "firstChildDiv";
        document.getElementById("root").firstElementChild.classList.value = "firstChildDiv";
        window.addEventListener('resize', getHeights);

        // getChatToken("QuietKendraUtica");
        // getUser();

        getSubscriptionDetails();

        // getNotifications();

        return () => {
            leaveConversation();
            window.removeEventListener('resize', getHeights);
            document.getElementById("root").classList.value = "container container-fluid";
            document.getElementById("root").firstElementChild.firstElementChild.classList.value = "";
            document.getElementById("root").firstElementChild.classList.value = "";
        };
    }, [])

    useEffect(() => {
        if (toggleLeftMenu) {
            document.getElementById("asideContainer").classList = "col-md-3 col-12 d-flex flex-column";
            if (!document.getElementById("mainContainer").classList.contains("d-none")) {
                document.getElementById("mainContainer").classList.add("d-none");
            }
        } else {
            document.getElementById("asideContainer").classList = "col-md-3 d-md-block col-12 d-none";
            if (document.getElementById("mainContainer").classList.contains("d-none")) {
                document.getElementById("mainContainer").classList.remove("d-none");
                getHeights();
            }
        }
    }, [toggleLeftMenu]);

    useEffect(() => {
        if (search.status) {
            document.getElementById("searchInput").focus();
        }
    }, [search.status]);

    useEffect(() => {
        removeMark();
        if (search.value) {
            currentSearchPage = 0;
            searchResult = [];
            performSearch();
        }
    }, [search.value]);

    useEffect(() => {
        if (!showNewMessageLine)
            scrollToBottom();
        if (currentSearchResult) {
            console.log("addMessage");
            // setTimeout(() => {
            let element = document.getElementById(`msg${currentSearchResult.index}`);
            for (let i = 0; i < 10; i++) {
                element.parentElement.scrollIntoView();
            }
            // }, 50);
        }
    }, [messages.length])

    useEffect(() => {
        if (!showNewMessageLine && isTyping.identity === participants.secondary.identity)
            getHeights();
    }, [isTyping.status])

    useEffect(() => {
        if (selectedConversation) {
            // console.log("useEffect-updateSelectedConversation");
            selectedConversation.getParticipants().then(participantList => {
                // console.log('participantList', participantList);
                participantList.map(participant => {
                    participant.getUser().then(user => {
                        // console.log('user', user);
                        if (participant.identity === primaryClient.user.identity) {
                            setParticipants(participants => ({ ...participants, primary: { lastReadMessageIndex: participant.lastReadMessageIndex, identity: participant.identity, friendlyName: user.friendlyName, isOnline: user.isOnline, attributes: user.attributes } }));
                        } else {
                            if (user.attributes && notifications.newChatMessage.length > 0) {
                                for (let i = notifications.newChatMessage.length - 1; i >= 0; i--) {
                                    if (notifications.newChatMessage[i].description === user.attributes.email) {
                                        AuthService.markNotificationAsRead("ClientChat", notifications.newChatMessage[i].id);
                                    }
                                }
                            }
                            setParticipants(participants => ({ ...participants, secondary: { identity: participant.identity, friendlyName: user.friendlyName, isOnline: user.isOnline, attributes: user.attributes } }));
                        }
                        user.on('updated', (user) => {
                            // console.log("userUpdated");
                            setParticipants(participants => {
                                if (user.updateReasons.includes("reachabilityOnline") && user.user.identity === participants.secondary.identity) {
                                    return ({ ...participants, secondary: { ...participants.secondary, isOnline: user.user.isOnline } });
                                }
                                return participants;
                            })
                        })
                    })
                })
            })
            // toggleSidebar();
        }
    }, [updateSelectedConversation]);

    const loadEmojiKeyborad = () => {
        const picker = new EmojiButton();
        const trigger = document.querySelector('.trigger');
        picker.on('emoji', selection => {
            // `selection` object has an `emoji` property
            // containing the selected emoji
            onEmojiClick(null, selection);
        });
        trigger.addEventListener('click', () => picker.togglePicker(trigger));
    }

    const toggleSidebar = () => {
        // e.preventDefault();
        document.getElementById("asideContainer").classList.toggle("openSideContainer");
        document.getElementById("asideContainer").classList.toggle("closeSideContainer");
        document.getElementById("mainContainer").classList.toggle("openMainContainer");
        document.getElementById("mainContainer").classList.toggle("closeMainContainer");
        getHeights();
    }

    const getHeights = () => {
        try {
            const mainHeight = document.getElementById("mainContainer").offsetHeight;
            const headerHeight = document.getElementById("header").offsetHeight;
            const typingDivHeight = document.getElementById("typingDiv") ? document.getElementById("typingDiv").offsetHeight : 0;
            const footerHeight = document.getElementById("footer").offsetHeight;
            const chatDivHeight = mainHeight - headerHeight - typingDivHeight - footerHeight;
            document.getElementById('chatDiv').setAttribute("style", `height: ${chatDivHeight}px`);
            document.getElementById('chatDiv').style.height = `${chatDivHeight}px`;
            scrollToBottom();
        } catch (err) { }
    }

    const handleChatScroll = (e) => {
        let chatList = e.target;
        const value = chatList.scrollHeight - chatList.scrollTop - chatList.clientHeight;
        if (!showNewMessageLine && value > 200) {
            setShowNewMessageLine(true)
        } else if (showNewMessageLine && value < 200) {
            setShowNewMessageLine(false)
        }
        if (!showChatScrollDown && value > 500) {
            setShowChatScrollDown(true)
        } else if (showChatScrollDown && value < 500) {
            setShowChatScrollDown(false)
        }
        // if (currentSearchResult) {
        //     let element = document.getElementById(`msg${currentSearchResult.index}`);
        //     element.parentElement.scrollIntoView();
        // }
        // console.log("scrollHeight", chatList.scrollHeight, "scrollTop", chatList.scrollTop, "clientHeight", chatList.clientHeight);
        if (chatList.scrollTop < 50 && selectedConversationPage && selectedConversationPage.hasPrevPage && !isShowMoreLoading) {
            const initialHeight = chatList.scrollHeight;
            loadOldChat("handleChatScroll").then(() => {
                chatList.scrollTop = chatList.scrollHeight - initialHeight;
            });
        }
    }

    function scrollToBottom() {
        try {
            let someElement = document.getElementById('chat');
            someElement.scrollTop = someElement.scrollHeight + document.getElementById('chat').lastChild.offsetHeight;
        } catch (err) { }
    }

    const onEmojiClick = (emojiObject) => {
        setMessage(message => message + emojiObject.emoji);
    }

    const getNotifications = () => {
        AuthService.getNotifications().then(data => {
            let temp = { newChatMessage: [] };
            Promise.all(data.notifications.ClientChat.map(item => {
                if (!item.readStatus && item.title === "newChatMessage") {
                    temp.newChatMessage.push({ id: item._id, description: item.description });
                }
            })).then(() => {
                setNotifications(temp);
            })
        })
    }

    const getSubscriptionDetails = () => {
        ClientService.getSubscription().then(subscription => {
            setSubscriptionDetail(subscription.data);
            // console.log("subscription", subscription);
            if (subscription.data) {
                ClientService.getClientProfileImage().then(clientDetails => {
                    // console.log("clientDetails", clientDetails);
                    setUser({ ...user, profileImage: clientDetails.profileImage });
                    ClientService.getChatProviderDetails().then(providerDetails => {
                        // console.log("providerDetails", providerDetails);
                        setSelectedProvider(providerDetails.selectedProvider);
                        setListOfSessions(providerDetails.sessions);
                        getChatToken(`client_${clientDetails.id}`);
                        // getChatToken('QuietKendraUtica');
                    }).catch(err => console.log("err", err));
                })
            }
        })
    }

    const getUser = () => {
        // instead of this just get sid from client or the subId
        ChatService.getConversation(user.email).then(conversations => {
            conversations.conversations.map(item => {
                item.participants.map(participant => {
                    if (user.email === participant.identity && user.selectedRole === "client") {
                        ClientService.getClientProfileImage().then(data => {
                            setUser({ ...user, profileImage: data.profileImage });
                            ClientService.getChatProviderDetails().then(providerDetails => {
                                // console.log(providerDetails.selectedProvider);
                                setSelectedProvider(providerDetails.selectedProvider);
                                setListOfSessions(providerDetails.sessions);
                                // console.log("getUser");
                                getChatToken("QuietKendraUtica");
                            });
                        })
                    }
                    //  else if (user.email === "axyz0261@gmail.com" && participant.identity === "axyz0261@gmail.com") {
                    //     getChatToken("YawningMufasaJamestown");
                    // }
                })
            })
        })
    }

    const getChatToken = (identity) => {
        // console.log("getToken");
        setStatusString("Fetching user details…");
        ChatService.getChatToken(identity).then(data => {
            connectMessagingClient(data.token);
        })
    }

    const connectMessagingClient = (token) => {
        // console.log("connectMessagingClient");
        ConversationsClient.create(token).then(client => {
            setStatusString("Connecting to chat...");
            primaryClient = client;
            client.on('tokenAboutToExpire', () => {
                ChatService.getChatToken(client.user.identity).then(data => {
                    client.updateToken(data.token);
                })
            });
            client.on("connectionStateChanged", (state) => {
                if (state === "connecting") {
                    setStatusString("Connecting to chat...");
                    // console.log("Connecting to Twilio…");
                    // setStatus("default");
                }
                if (state === "connected") {
                    setStatusString("You are connected to chat.");
                    setConnectionLoading(false);
                    // console.log("You are connected");
                    // setStatus("success");
                }
                if (state === "disconnecting") {
                    setStatusString("Disconnecting from chat…");
                    // console.log("Disconnecting from Twilio…");
                    // setConversationsReady(false);
                    // setStatus("default");
                }
                if (state === "disconnected") {
                    setStatusString("Disconnected from chat.");
                    // console.log("Disconnected");
                    // setConversationsReady(false);
                    // setStatus("warning");
                }
                if (state === "denied") {
                    setStatusString("Failed to connect.");
                    // console.log("Failed to connect");
                    // setConversationsReady(false);
                    // setStatus("error");
                }
            });

            client.on("conversationJoined", (conversation) => {
                // console.log('conversationJoined', conversation);
                // setSelectedConversation(conversation);
                // subscribeConversationEvents(conversation);
                let tempConversationId = '';
                setSubscriptionDetail(subscriptionDetail => {
                    tempConversationId = subscriptionDetail.conversation.twilioId;
                    return subscriptionDetail;
                });
                if (tempConversationId === conversation.sid) {
                    joinConversation(conversation);
                }
                // updateConversationList(conversation);
            });

            client.on("conversationLeft", (thisConversation) => {
                // console.log('conversationLeft');
                setConversations(conversations.filter((conversation) => conversation !== thisConversation));
            });

        })
    }

    const updateConversationList = (conversation) => {
        // console.log("updateConversationList");
        if (conversations.filter(item => item.sid === conversation.sid).length === 0) {
            setConversations(conversations => [...conversations, conversation]);
        }
    }

    const subscribeConversationEvents = (currentChannel) => {
        currentChannel.on('updated', (conversation) => {
            // console.log('conversationUpdated');
            if (conversation.updateReasons.includes("lastMessage")) {
                let isCalled = false;
                setParticipants(participants => {
                    if (!isCalled) {
                        isCalled = true;
                        if (!participants.secondary.isOnline) {
                            AuthService.addNotification(participants.secondary.attributes.email, "ProviderChat", "General", "newChatMessage", participants.primary.attributes.email).then(() => {
                                // console.log("Notification added");
                            });
                        }
                    }
                    return participants;
                });
                setSelectedConversationMessageStatus(selectedConversationMessageStatus => ({ ...selectedConversationMessageStatus, lastMessage: conversation.conversation.lastMessage }));
            }
        })

        currentChannel.on('participantJoined', (participant) => {
            // console.log('participantJoined', participant);
            // addParticipant(participant);
        });

        currentChannel.on('participantLeft', (participant) => {
            // console.log('participantLeft', participant);
            // removeParticipant(participant);
        })

        currentChannel.on('participantUpdated', (participant) => {
            // console.log('participantUpdated');
            if (participant.updateReasons.includes("lastReadMessageIndex")) {
                let temp = false;
                setShowNewMessageLine(showNewMessageLine => {
                    temp = showNewMessageLine;
                    return showNewMessageLine;
                });
                if (!temp) {
                    setParticipants(participants => ({ ...participants, primary: { ...participants.primary, lastReadMessageIndex: participant.participant.lastReadMessageIndex } }));
                }
            }
        })

        currentChannel.on('messageAdded', (item) => {
            // console.log('messageAdded');
            let temp = false;
            setShowNewMessageLine(showNewMessageLine => {
                temp = showNewMessageLine;
                return showNewMessageLine;
            });
            if (!temp) {
                markMessageAsRead(item.index);
            }
            if (item.body === "ixe0BBjvIiwwoT7UNk5iVfNjfUJTTVup0IqGBuUTAgc=") {
                setShowCallRequestPopup(true);
            } else if (item.body === "1QLPeeVffQQI21QS4Uw1krzeh4R6M2GuWGWD9eGbLhA=") {
                setShowVideoRequestPopup(true);
            } else {
                addMessage(item);
            }
            if (item.author !== primaryClient.user.identity) {
                audio.play();
            }
        })

        currentChannel.on('typingStarted', (member) => {
            setIsTyping({ status: true, identity: member.identity });
        });

        currentChannel.on('typingEnded', (member) => {
            setIsTyping({ status: false, identity: '' });
        });

        getMessagesFromConversation(currentChannel);
    }

    const getMessagesFromConversation = (currentChannel) => {
        // console.log("getMsgFromConversation");
        copyMessages = [];
        setMessages([]);
        // setSelectedConversationPage(null);
        selectedConversationPage = null;
        currentChannel.getMessages(pageSize).then(async fetchedmessages => {
            // setSelectedConversationPage(fetchedmessages);
            selectedConversationPage = fetchedmessages;
            Promise.all(
                fetchedmessages.items.map(item => {
                    if (item.body !== "ixe0BBjvIiwwoT7UNk5iVfNjfUJTTVup0IqGBuUTAgc=" && item.body !== "1QLPeeVffQQI21QS4Uw1krzeh4R6M2GuWGWD9eGbLhA=") {
                        addMessage(item);
                    }
                })
                // setMessages(fetchedmessages.items);
                // addMessage({ isCustomMessage: true, body: `${primaryClient.user.identity} has joined.` });
            ).then(() => {
                getHeights();
            })
        });
    }

    const joinConversation = (conversation) => {
        if (selectedConversation && selectedConversation.sid === conversation.sid) {
            // console.log("joinConversation-If");
            return;
        } else {
            // console.log("joinsConversation-Else");
            if (selectedConversation) {
                selectedConversation.removeAllListeners();
            }
            let latestSubscriptionDetail = null;
            setSubscriptionDetail(data => {
                latestSubscriptionDetail = data;
                return data
            })
            // if (latestSubscriptionDetail.conversation.twilioId == conversation.sid) {
            // console.log("joined it")
            selectedConversationPage = null;
            copyMessages = [];
            currentSearchResult = null;
            currentSearchPage = 0;
            searchResult = [];
            setSearch({ status: false, value: "" });
            setSelectedConversation(conversation);
            // setSelectedConversationMessageStatus({ lastMessage: conversation.lastMessage, lastReadMessageIndex: conversation.lastReadMessageIndex });
            setSelectedConversationMessageStatus({ lastMessage: conversation.lastMessage });
            subscribeConversationEvents(conversation);
            setUpdateSelectedConversation(updateSelectedConversation => !updateSelectedConversation);
            // }
        }
    }

    const leaveConversation = () => {
        // console.log("leaveConversation");
        if (primaryClient.user.identity) {
            primaryClient.shutdown().then(() => {
                setStatusString("");
                setConversations([]);
                setSelectedConversation(null);
                // setSelectedConversationPage(null);
                selectedConversationPage = null;
                searchResult = [];
                setUpdateSelectedConversation(updateSelectedConversation => !updateSelectedConversation);
                setIsTyping({ status: false, identity: "" });
                setMessage("");
                setMessages([]);
                copyMessages = [];
            });
        }
    }

    const addMessage = (item) => {
        setMessages(messages => [...messages, item]);
        copyMessages.push(item);
    }

    const markMessageAsRead = (index) => {
        let isCalled = false;
        setSelectedConversation(selectedConversation => {
            if (!isCalled) {
                isCalled = true;
                selectedConversation.updateLastReadMessageIndex(index)
                    .then(() => {
                        // console.log("marked as read", index);
                    });
            }
            return selectedConversation;
        });
    }

    const handleTyping = (e) => {
        if (e.keyCode === 13) {
            document.getElementById('sendButton').click();
        } else if (selectedConversation) {
            selectedConversation.typing();
        }
    }

    const sendMessage = () => {
        if (message !== '') {
            selectedConversation.sendMessage(message);
            setMessage('');
        }
    }

    const loadOldChat = async (src) => {
        counter = counter + 1;
        // console.log("called from", src, counter);
        setIsShowMoreLoading(true);
        await selectedConversationPage.prevPage().then(page => {
            Promise.all(
                page.items.map(item => {
                    if (item.body !== "ixe0BBjvIiwwoT7UNk5iVfNjfUJTTVup0IqGBuUTAgc=" && item.body !== "1QLPeeVffQQI21QS4Uw1krzeh4R6M2GuWGWD9eGbLhA=") {
                        return item;
                    }
                })
            ).then(newMessages => {
                // setSelectedConversationPage(page);
                selectedConversationPage = page;
                copyMessages = newMessages.concat(copyMessages);
                setMessages(messages => newMessages.concat(messages));
                setIsShowMoreLoading(false);
            });
        });
    }

    // search functions
    const handleSearch = (value) => {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
            setSearch({ ...search, value: value });
        }, 500);
    }

    const performSearch = async () => {
        // console.log("copyMessages.length", copyMessages.length, "currentSearchPage", currentSearchPage);
        let tempArray = [];
        let start = copyMessages.length - 1 - (pageSize * currentSearchPage);
        let end = 0;
        // console.log("start", start, "end", end);
        for (let i = start; i >= end; i--) {
            let position = copyMessages[i].body.toLowerCase().search(search.value.toLowerCase());
            if (position > -1)
                tempArray.push({ start: position, index: copyMessages[i].index });
        }
        searchResult.push(tempArray);
        // console.log("searchResult", searchResult);
        if (tempArray.length > 0) {
            if (searchResult.length !== 0) {
                currentSearchPage = searchResult.length - 1;
            }
            currentSearchResult = searchResult[currentSearchPage][0];
            await addMark();
        } else {
            if (!isShowMoreLoading && copyMessages.length > 0 && selectedConversationPage && selectedConversationPage.hasPrevPage) {
                await loadOldChat("performSearch").then(() => {
                    currentSearchPage = currentSearchPage + 1;
                    performSearch();
                });
            }
        }
    }

    const searchUpDown = async (direction) => {
        if (searchResult.length > 0) {
            let arrayIndex = await searchResult[currentSearchPage].findIndex(item => item.index === currentSearchResult.index);
            // console.log("arrayIndex", arrayIndex);
            if (arrayIndex > -1) {
                if (direction === "up") {
                    if (searchResult[currentSearchPage].length > 0 && searchResult[currentSearchPage][(searchResult[currentSearchPage].length - 1)].index < currentSearchResult.index) {
                        await removeMark();
                        currentSearchResult = searchResult[currentSearchPage][arrayIndex + 1];
                        await addMark();
                    } else {
                        if (searchResult.length > (currentSearchPage + 1)) {
                            currentSearchPage = currentSearchPage + 1;
                            while (searchResult[currentSearchPage].length === 0) {
                                currentSearchPage = currentSearchPage + 1;
                            }
                            await removeMark();
                            currentSearchResult = searchResult[currentSearchPage][0];
                            await addMark();
                        } else {
                            if (!isShowMoreLoading && copyMessages.length > 0 && selectedConversationPage && selectedConversationPage.hasPrevPage) {
                                await loadOldChat("searchUpDown").then(() => {
                                    currentSearchPage = currentSearchPage + 1;
                                    performSearch();
                                });
                            } else {
                                // console.log("The end up");
                            }
                        }
                    }
                } else if (direction === "down") {
                    if (searchResult[currentSearchPage][0].index > currentSearchResult.index) {
                        // console.log("currentSearchPage", currentSearchPage, "searchResult", searchResult, "current", currentSearchResult);
                        await removeMark();
                        currentSearchResult = searchResult[currentSearchPage][arrayIndex - 1];
                        await addMark();
                    } else if (currentSearchPage > 0) {
                        // console.log("currentSearchPage", currentSearchPage, "searchResult", searchResult, "current", currentSearchResult);
                        currentSearchPage = currentSearchPage - 1;
                        while (searchResult[currentSearchPage].length === 0) {
                            currentSearchPage = currentSearchPage - 1;
                        }
                        await removeMark();
                        currentSearchResult = searchResult[currentSearchPage][(searchResult[currentSearchPage].length - 1)];
                        await addMark();
                    } else {
                        // console.log("The end down");
                    }
                }
            }
        }
    }

    const addMark = async () => {
        if (currentSearchResult) {
            let element = document.getElementById(`msg${currentSearchResult.index}`);
            let text = element.innerText;
            let re = new RegExp(search.value, "gi"); // search for all instances
            let newText = text.replace(re, `<mark>${text.substr(currentSearchResult.start, search.value.length)}</mark>`);
            element.innerHTML = newText;
            element.parentElement.scrollIntoView();
        }
    }

    const removeMark = async () => {
        if (currentSearchResult) {
            let element = document.getElementById(`msg${currentSearchResult.index}`);
            let text = element.innerText;
            let newText = text.replace("<mark>", "");
            newText = newText.replace("</mark>", "");
            element.innerHTML = newText;
        }
    }

    const clearSearch = async () => {
        searchResult = [];
        setSearch({ ...search, value: "" });
        document.getElementById("searchInput").value = "";
    }

    const toggleDetails = () => setIsOpenDetails(!isOpenDetails);
    const toggleUpcoming = () => setIsOpenUpcoming(!isOpenUpcoming);
    const togglePrevious = () => setIsOpenPrevious(!isOpenPrevious);

    const handleJoyrideCallback = (data) => {
        const { status, type } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            if (!user.guideTakenFor.includes("ClientChat")) {
                AuthService.markVisited("ClientChat");
                setUser({ ...user, guideTakenFor: [...user.guideTakenFor, "ClientChat"] });
            }
            setTutorial({ ...tutorial, status: false });
        }
    };

    const getHelpers = (paramHelpers) => {
        helpers = paramHelpers;
    };

    // function's return
    return (
        true ?
            <div id="clientChatDiv" className="clientChatWindow row m-0">
                <ErrorBoundary errorAt="At Client ClientChat Joyride">
                    <Joyride
                        callback={handleJoyrideCallback}
                        continuous={true}
                        getHelpers={getHelpers}
                        run={tutorial.status}
                        scrollToFirstStep={true}
                        showProgress={false}
                        showSkipButton={false}
                        steps={tutorial.steps}
                        locale={{ last: 'Finish' }}
                        styles={{
                            options: {
                                primaryColor: "rgb(56, 78, 115)",
                                zIndex: 10000,
                            },
                        }}
                    />
                </ErrorBoundary>
                {connectionLoading ? <div id="overlay"><div className="h-100 d-flex"><h3 className="m-auto text-center">{statusString}</h3></div></div> : null}
                <div id="asideContainer" className="col-md-3 col-12 d-flex flex-column">
                    <div className="d-flex align-items-center">
                        {toggleLeftMenu ? (
                            <h4 className="backBtn" onClick={() => setToggleLeftMenu(false)}>
                                <i className="fas fa-chevron-left" style={{ color: "white" }}></i>
                            </h4>
                        ) : null}

                        <h5 className="mt-1 ml-2">
                            Your Counsellor
                        </h5>
                    </div>
                    <div className="d-flex flex-column align-items-center">
                        <i style={{ fontSize: "2rem", margin: "1rem", color: "white" }} className="fas fa-user"></i>
                        <h5>
                            {selectedProvider.name}
                        </h5>
                    </div>

                    {/* Other details */}
                    <div className="otherDetails mt-2">
                        <button
                            type="button"
                            onClick={toggleDetails}
                            className="pb-2 d-flex align-items-center justify-content-between px-0 mx-2 mb-2"
                        >
                            Other Details
                            {isOpenDetails ? (
                                <i className="fas fa-angle-up icon" style={{ fontSize: "1.4rem", color: "white" }}></i>
                            ) : (
                                <i className="fas fa-angle-right icon" style={{ fontSize: "1.4rem", color: "white" }}></i>
                            )}
                        </button>
                        <Collapse isOpen={isOpenDetails}>
                            <ul className="ml-3">
                                <div className="d-flex align-items-center">
                                    <i className="fas fa-map-marker-alt mr-2"></i>
                                    <li className="ml-2">{`${selectedProvider.city}, ${selectedProvider.state}, ${selectedProvider.country}`}</li>
                                </div>

                                <div className="d-flex align-items-center my-1">
                                    <i className="fas fa-envelope mr-2"></i>
                                    <li className="ml-2">{selectedProvider.email}</li>
                                </div>

                                <div className="d-flex align-items-center my-1">
                                    <i className="fas fa-phone-alt mr-2"></i>
                                    <li className="ml-2">{selectedProvider.phone}</li>
                                </div>
                            </ul>
                        </Collapse>
                    </div>

                    {/* Upcoming Sessions */}
                    <div className="upcomingSessions">
                        <button
                            type="button"
                            onClick={toggleUpcoming}
                            className="pb-2 px-0 mb-2 mx-2 d-flex align-items-center justify-content-between"
                        >
                            Upcoming Sessions:
                            {isOpenUpcoming ? (
                                <i className="fas fa-angle-up icon" style={{ fontSize: "1.4rem", color: "white" }}></i>
                            ) : (
                                <i className="fas fa-angle-right icon" style={{ fontSize: "1.4rem", color: "white" }}></i>
                            )}
                        </button>
                        <Collapse isOpen={isOpenUpcoming}>
                            <ul>
                                {
                                    listOfSessions.upcomingSessions.map((item, index) => (
                                        <div key={index} className="d-flex flex-row justify-content-between align-items-center mx-2">
                                            {
                                                item.modeOfServiceSelected === "call" ?
                                                    <i className="fas fa-phone-alt mx-2"></i> :
                                                    <i className="fas fa-video mx-2"></i>
                                            }
                                            <li className="mr-5">{moment(item.date).format('DD/MM/YYYY')}</li>
                                            <li className="ml-4 mr-2">{moment(item.date).format('hh:mm A')}</li>
                                        </div>
                                    ))
                                }
                            </ul>
                        </Collapse>
                    </div>

                    {/* Previous Sessions */}
                    <div className="previousSessions">
                        <button
                            type="button"
                            onClick={togglePrevious}
                            className="pb-2 px-0 mb-2 mx-2 d-flex align-items-center justify-content-between"
                        >
                            Previous Sessions:
                            {isOpenPrevious ? (
                                <i className="fas fa-angle-up icon" style={{ fontSize: "1.4rem", color: "white" }}></i>
                            ) : (
                                <i className="fas fa-angle-right icon" style={{ fontSize: "1.4rem", color: "white" }}></i>
                            )}
                        </button>
                        <Collapse isOpen={isOpenPrevious}>
                            <ul>
                                {
                                    listOfSessions.completedSessions.map((item, index) => (
                                        <div key={index} className="d-flex flex-row justify-content-between align-items-center mx-2">
                                            {
                                                item.modeOfServiceSelected === "call" ?
                                                    <i className="fas fa-phone-alt mx-2"></i> :
                                                    <i className="fas fa-video mx-2"></i>
                                            }
                                            <li className="mr-5">{moment(item.date).format('DD/MM/YYYY')}</li>
                                            <li className="ml-4 mr-2">{moment(item.date).format('hh:mm A')}</li>
                                        </div>
                                    ))
                                }
                            </ul>
                        </Collapse>
                    </div>
                </div>

                <div id="mainContainer" className="col-md-9 col-12 d-md-block openMainContainer">
                    <div id="header" className="d-flex align-items-center">

                        {
                            search.status ? [
                                <Button key="1" className="iconButton my-auto" style={{ color: colors.primary }} onClick={() => { setSearch({ status: false, value: "" }); removeMark() }}><i className="fas fa-arrow-left"></i></Button>,
                                <InputGroup key="2" className="d-flex my-auto" style={{ width: "100%", marginRight: '15px', border: "1px solid #ced4da", borderRadius: "0.25rem" }}>
                                    <Input id="searchInput" type="text" style={{ border: "none" }} placeholder="Search..." onChange={(e) => handleSearch(e.target.value)} />
                                    <button className="btn bg-transparent" style={{ color: colors.primary }} onClick={() => clearSearch()}><i className="fa fa-times"></i></button>
                                </InputGroup>,
                                <Button key="3" className="iconButton my-auto" style={{ marginRight: '15px', color: colors.primary }} onClick={() => searchUpDown("up")} ><i className="fas fa-chevron-up"></i></Button>,
                                <Button key="4" className="iconButton my-auto" style={{ color: colors.primary }} onClick={() => searchUpDown("down")}><i className="fas fa-chevron-down"></i></Button>
                            ] : [
                                <i
                                    key="1"
                                    style={{ fontSize: "2rem", color: colors.primary }}
                                    className="fas fa-user mr-2"
                                    onClick={() => setToggleLeftMenu(true)}
                                ></i>,
                                <div key="2" className="display" onClick={() => setToggleLeftMenu(true)}>
                                    <h2>{selectedProvider.name || participants.secondary.friendlyName}</h2>
                                    <h3>{selectedConversation ? participants.secondary.isOnline ? "online" : "offline" : ""}</h3>
                                </div>,
                                selectedConversation ? [
                                    <Button key="3" className="iconButton my-auto ml-auto" style={{ color: colors.primary }} onClick={() => setSearch({ status: true, value: "" })}><i className="fas fa-search"></i></Button>,
                                    <Link key="4" to='/client/booksession'>
                                        <div className="actionBtnContainer">
                                            <div className="actionBtn d-icon">
                                                <i className="fas fa-phone-alt d-icon"></i>
                                            </div>
                                        </div>
                                    </Link>,
                                    <Link key="5" to='/client/booksession'>
                                        <div className="actionBtnContainer">
                                            <div className="actionBtn d-icon">
                                                <i className="fas fa-video d-icon"></i>
                                            </div>
                                        </div>
                                    </Link>
                                ]
                                    :
                                    null
                            ]
                        }

                        {/* Mobile Menu */}
                        <input
                            type="checkbox"
                            id="nav-toggle"
                            className="nav-toggle"
                            onChange={() => setToggleTopMenu(!toggleTopMenu)}
                        ></input>

                        <nav className={toggleTopMenu ? "" : "d-none"}>
                            <ul className="topMenuMobile">
                                <div className="d-flex flex-row justify-content-between align-items-center menu">
                                    <h5>Menu</h5>
                                </div>

                                {/* <div className="d-flex flex-row align-items-center disp">
                                    <div className="actionBtn">
                                        <img height="20px" width="auto" src={searchIcon} alt="search" />
                                    </div>
                                    <li>Search</li>
                                </div> */}
                                <Link to='/client/booksession'>
                                    <div className="d-flex flex-row align-items-center disp">
                                        <div className="actionBtn">
                                            <i className="fas fa-phone-alt my-auto"></i>
                                        </div>
                                        <li>Request a voice call</li>
                                    </div>
                                </Link>
                                <Link to='/client/booksession'>
                                    <div className="d-flex flex-row align-items-center disp">
                                        <div className="actionBtn">
                                            <i className="fas fa-video"></i>
                                        </div>
                                        <li>Request a video call</li>
                                    </div>
                                </Link>
                            </ul>
                        </nav>

                        <label htmlFor="nav-toggle" className="navbar">
                            {toggleTopMenu ? (
                                <i
                                    className="fas fa-times navCls mt-3"
                                    style={{ color: "white", zIndex: "300", fontSize: "24px" }}
                                ></i>
                            ) : (
                                <i className="fas fa-bars icon" style={{ fontSize: "24px" }}></i>
                            )}
                        </label>
                    </div>


                    <div id="chatDiv" style={{ height: "400px" }}>
                        <ul id="chat" onScroll={(e) => handleChatScroll(e)}>
                            {
                                isShowMoreLoading ?
                                    <li style={{ textAlign: 'center' }}>
                                        <span className="spinner-border spinner-border-sm"></span>
                                    </li>
                                    : null
                            }
                            {
                                messages.length === 0 ?
                                    <div className="d-flex h-100"><h5 className="m-auto">Seems like the conversation is empty. Send your first message by typing below.</h5></div>
                                    :
                                    messages.map((item, index) => ([
                                        item.isCustomMessage ?
                                            <li key={`message${index}`} data-index={index} style={{ textAlign: 'center' }}>
                                                <h2 style={{ fontWeight: '600', fontSize: '1rem' }}>{item.body}</h2>
                                            </li>
                                            :
                                            item.author === primaryClient.user.identity ?
                                                <li key={`message${index}`} data-index={index} className="me">
                                                    <div className="entete">
                                                        <h3>{moment(item.dateCreated).format('DD-MM-YYYY hh:mm A')}</h3>
                                                    </div>
                                                    <div id={`msg${item.index}`} className="message">
                                                        {item.body}
                                                    </div>
                                                </li>
                                                :
                                                <li key={`message${index}`} data-index={index} className="you">
                                                    <div className="entete">
                                                        <h3>{moment(item.dateCreated).format('DD-MM-YYYY hh:mm A')}</h3>
                                                    </div>
                                                    <div id={`msg${item.index}`} className="message">
                                                        {item.body}
                                                    </div>
                                                </li>,
                                        participants.primary.lastReadMessageIndex && (selectedConversationMessageStatus.lastMessage.index !== participants.primary.lastReadMessageIndex) && (item.index === participants.primary.lastReadMessageIndex) ?
                                            <li key="newMsg" data-index={index} style={{ textAlign: 'center', padding: '0', borderBottom: '3px solid #ff0000' }}>
                                                <h2 style={{ fontWeight: '600', fontSize: '1rem' }}>{selectedConversationMessageStatus.lastMessage.index - item.index} unread message{selectedConversationMessageStatus.lastMessage.index - item.index === 1 ? "" : "s"}</h2>
                                            </li>
                                            :
                                            null
                                    ]))
                            }
                            {
                                isTyping.status ?
                                    <li className="you">
                                        <div className="message typing-indicator">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </div>
                                    </li>
                                    : null
                            }
                        </ul>
                        {
                            showChatScrollDown ?
                                <div className="downArrowDiv" onClick={() => scrollToBottom()}>
                                    <span><i className="fas fa-angle-double-down"></i></span>
                                    {
                                        selectedConversationMessageStatus.lastMessage.index - participants.primary.lastReadMessageIndex ?
                                            <span className="badge">{selectedConversationMessageStatus.lastMessage.index - participants.primary.lastReadMessageIndex}</span>
                                            : null
                                    }
                                </div> : null
                        }
                    </div>
                    <div id="footer" className="d-flex">
                        {
                            subscriptionDetail.isActive ?
                                [
                                    <div style={{ position: "relative" }}>
                                        <Button
                                            className="iconButton trigger"
                                            style={{ marginRight: "15px" }}
                                            onLoad={loadEmojiKeyborad}
                                        >
                                            <i className="far fa-smile" style={{ color: "#384E73" }}></i>
                                        </Button>
                                    </div>,
                                    <Input
                                        style={{ marginRight: "15px", border: "none" }}
                                        placeholder="Type your message"
                                        value={message}
                                        onKeyDown={(e) => handleTyping(e)}
                                        onChange={(e) => setMessage(e.target.value)}
                                    ></Input>,
                                    <Button
                                        id="sendButton"
                                        className="iconButton d-flex flex-row justify-content-center align-items-center"
                                        onClick={() => sendMessage()}
                                    >

                                        <p className="ml-2 mr-3 mt-3" style={{ color: "white", fontSize: "1rem" }}>Send</p>
                                        <img
                                            height="16px"
                                            width="auto"
                                            src={sendIcon} />

                                    </Button>
                                ]
                                :
                                <div className="w-100 text-center">You cannot send message as user does not have any active subscription plan</div>

                        }
                    </div>
                </div>
            </div >
            :
            <div id="container" className="clientChatWindow row m-0">
                {connectionLoading ? <div id="overlay"><div className="h-100 d-flex"><h3 className="m-auto text-center">{statusString}</h3></div></div> : null}
                <div id="asideContainer" className="col-md-3 col-12 d-flex flex-column closeSideContainer">
                    <h4 className="backBtn" onClick={() => toggleSidebar()}><i className="fas fa-arrow-left"></i></h4>
                    {/* <div className="mx-auto text-center">
                        <img className="m-auto imageContainer" src={selectedProvider.profileImage} alt="Selected Provider" />
                    </div> */}
                    <div className="mx-auto text-center" style={{ fontSize: "1.6rem" }}>
                        {selectedProvider.name}
                    </div>
                    <div className="my-auto text-center descriptionContainer">
                        {/* <textarea readOnly value="Practicing psychologist, psychometrician and a professor of management having more than 20 years of experience. Recipient of Women's Achievement Award - 2020. Active member of Rakshita Welfare, NGO, Bhopal. Has provided counselling to scores of people of every walk of life be it a child or an adult or a teenager. Practicing psychologist, psychometrician and a professor of management having more than 20 years of experience. Recipient of Women's Achievement Award - 2020. Active member of Rakshita Welfare, NGO, Bhopal. Has provided counselling to scores of people of every walk of life be it a child or an adult or a teenager. "></textarea> */}
                        {selectedProvider.description}
                    </div>
                    <div className="d-flex justify-content-around text-center">
                        <div className="actionBtnContainer">
                            <div className="actionBtn mx-auto"><i className="fas fa-phone-alt my-auto"></i></div>
                            <div className="actionBtnText">Book call session</div>
                        </div>
                        <div className="actionBtnContainer">
                            <div className="actionBtn mx-auto"><i className="fas fa-video my-auto"></i></div>
                            <div className="actionBtnText">Book video session</div>
                        </div>
                    </div>
                </div>
                <div id="mainContainer" className="col-md-9 col-12 openMainContainer">
                    <div id="header" className="d-flex">
                        <img height="55px" width="55px" src={selectedProvider.profileImage} alt="profileImage" onClick={() => toggleSidebar()} />
                        <div>
                            <h2>{participants.secondary.identity || participants.secondary.friendlyName}</h2>
                            <h3>{selectedConversation ? participants.secondary.isOnline ? "online" : "offline" : ""}</h3>
                        </div>
                        {
                            selectedConversation ?
                                // [
                                //     search.visible ? <Input type="text" className="ml-auto" style={{ marginRight: '15px' }} value={search.value} /> :
                                //         <Button key="headerBtn1" className="iconButton ml-auto" style={{ marginRight: '15px' }} onClick={() => setSearch({ visible: false, value: "" })}><i className="fas fa-search"></i></Button>,
                                //     ]
                                <Button key="headerBtn2" className="iconButton ml-auto" onClick={() => props.history.push('dashboard')}><i className="fas fa-sign-out-alt"></i></Button>
                                :
                                null
                        }
                    </div>
                    <div id="chatDiv">
                        <ul id="chat" onScroll={(e) => handleChatScroll(e)}>
                            {
                                isShowMoreLoading ?
                                    <li style={{ textAlign: 'center' }}>
                                        <span className="spinner-border spinner-border-sm"></span>
                                    </li>
                                    : null
                            }
                            {
                                messages.map((item, index) => ([
                                    item.isCustomMessage ?
                                        <li key={`message${index}`} data-index={index} style={{ textAlign: 'center' }}>
                                            <h2 style={{ fontWeight: '600', fontSize: '1rem' }}>{item.body}</h2>
                                        </li>
                                        :
                                        item.author === primaryClient.user.identity ?
                                            <li id={`msg${index}`} key={`message${index}`} data-index={index} className="me">
                                                <div className="entete">
                                                    <h3>{moment(item.dateCreated).format('DD-MM-YYYY hh:mm A')}</h3>
                                                </div>
                                                <div className="message">
                                                    {item.body}
                                                </div>
                                            </li>
                                            :
                                            <li id={`msg${index}`} key={`message${index}`} data-index={index} className="you">
                                                <div className="entete">
                                                    <h3>{moment(item.dateCreated).format('DD-MM-YYYY hh:mm A')}</h3>
                                                </div>
                                                <div className="message">
                                                    {item.body}
                                                </div>
                                            </li>,
                                    participants.primary.lastReadMessageIndex && (selectedConversationMessageStatus.lastMessage.index !== participants.primary.lastReadMessageIndex) && (item.index === participants.primary.lastReadMessageIndex) ?
                                        <li key="newMsg" data-index={index} style={{ textAlign: 'center', padding: '0', borderBottom: '3px solid #ff0000' }}>
                                            <h2 style={{ fontWeight: '600', fontSize: '1rem' }}>{selectedConversationMessageStatus.lastMessage.index - item.index} unread message{selectedConversationMessageStatus.lastMessage.index - item.index === 1 ? "" : "s"}</h2>
                                        </li>
                                        :
                                        null
                                ]))
                            }
                            {
                                isTyping.status ?
                                    <li className="you">
                                        <div className="message typing-indicator">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </div>
                                    </li>
                                    : null
                            }
                        </ul>
                        {
                            showChatScrollDown ?
                                <div className="downArrowDiv" onClick={() => scrollToBottom()}>
                                    <span><i className="fas fa-angle-double-down"></i></span>
                                    {
                                        selectedConversationMessageStatus.lastMessage.index - participants.primary.lastReadMessageIndex ?
                                            <span className="badge">{selectedConversationMessageStatus.lastMessage.index - participants.primary.lastReadMessageIndex}</span>
                                            : null
                                    }
                                </div> : null
                        }
                    </div>
                    <div id="footer" className="d-flex">
                        <div style={{ position: "relative" }}>
                            <Button className="iconButton trigger" style={{ marginRight: '15px' }}><i className="fas fa-laugh"></i></Button>
                        </div>
                        <Input style={{ marginRight: '15px' }} placeholder="Type your message" value={message} onChange={(e) => setMessage(e.target.value)} onKeyDown={(e) => handleTyping(e)}></Input>
                        <Button id="sendButton" className="iconButton" onClick={sendMessage}><i className="far fa-paper-plane"></i></Button>
                    </div>
                </div>
                <Modal size="sm" isOpen={showCallRequestPopup} centered={true} >
                    <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setShowCallRequestPopup(false)}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Try call session</span></ModalHeader>
                    <ModalBody style={{ textAlign: 'center' }}>
                        <Label>Try our call service</Label>
                        <br />
                        <Button className="my-2" onClick={() => props.history.push('booksession')}>Book now</Button>
                    </ModalBody>
                </Modal>
                <Modal size="sm" isOpen={showVideoRequestPopup} centered={true} >
                    <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setShowVideoRequestPopup(false)}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Try video session</span></ModalHeader>
                    <ModalBody style={{ textAlign: 'center' }}>
                        <Label>Try our video service</Label>
                        <br />
                        <Button className="my-2" onClick={() => props.history.push('booksession')}>Book now</Button>
                    </ModalBody>
                </Modal>
            </div>
    )
}

export default ClientChat;